export default "__VITE_ASSET__CL09PQ9M__"